import { Trans, useTranslation } from 'react-i18next';
import { Box, Dialog, DialogContent, Typography } from '@mui/material';
import ForwardToInboxIcon from '@mui/icons-material/ForwardToInbox';

const EmailSentModal = ({ open, onClose }) => {
  const { t } = useTranslation(['onboarding']);

  return (
    <Dialog
      open={open}
      onClose={onClose}
      slotProps={{
        paper: {
          sx: {
            borderRadius: 2,
            p: 3,
            maxWidth: 400,
          },
        },
      }}
    >
      <DialogContent sx={{ textAlign: 'center', py: 3 }}>
        <Box sx={{ mb: 2 }}>
          <ForwardToInboxIcon sx={{ fontSize: 56, color: 'text.secondary' }} />
        </Box>

        <Typography variant="h5" component="h2" sx={{ fontWeight: 500, mb: 2 }}>
          {t('create_account.modal.email_sent.title')}
        </Typography>

        <Typography variant="body1" sx={{ mb: 3, color: 'text.secondary' }}>
          <Trans
            i18nKey="create_account.modal.email_sent.subtitle"
            ns="onboarding"
            components={{
              link: (
                <Box
                  component="span"
                  sx={{ color: 'primary.main', textDecoration: 'underline' }}
                />
              ),
            }}
          />
        </Typography>
      </DialogContent>
    </Dialog>
  );
};

export default EmailSentModal;
